import Footer from "../components/Footer/Footer";
import QuickInquiry from "../components/QuickInquiry/QuickInquiry";
import Navbar from "../components/Navbar/Navbar";
import Projects from "../components/Projects/Projects";

const Project = () => {
    return (
        <>
            <Navbar />
            <Projects />
            <QuickInquiry />
            <Footer />
        </>
    )
}

export default Project;